import {
  Text,
  Breadcrumbs,
  BreadcrumbsAnchor,
  BreadcrumbsItem,
  BreadcrumbsDivider,
  BreadcrumbsContainer,
} from '@intellecteu/common-ui';

export const DetailsBreadcrumbs = ({ entityName }: { entityName: string }) => {
  return (
    <>
      <BreadcrumbsAnchor
        component={
          <Text size={Text.size.xs} color={Text.color.darkGrey}>
            {entityName}
          </Text>
        }
      />
      <Breadcrumbs
        components={{
          Item: BreadcrumbsItem,
          Divider: BreadcrumbsDivider,
          Container: BreadcrumbsContainer,
        }}
      />
    </>
  );
};
